import { FeedBanner } from '../components/FeedBanner';
import { LatencyPanel } from '../components/LatencyPanel';
import { ProviderPanel } from '../components/ProviderPanel';
import { AuditPanel, SystemHealthPanel } from '../components/SystemPanels';
import { useFeedView } from '../hooks/useFeedView';

export function SystemPage() {
  const view = useFeedView();
  return (
    <>
      <div className="page__header">
        <h1>System</h1>
        <p className="page__lede">Provider health, latency, connections and the audit trail.</p>
      </div>
      <FeedBanner view={view} />
      <div className="grid grid--2">
        <SystemHealthPanel />
        <ProviderPanel />
        <LatencyPanel />
        <AuditPanel limit={40} />
      </div>
    </>
  );
}
